module.exports = __webpack_public_path__ + "img/fx.b5cab8af.png";